export const ALL_LESSONS_KEY = 'Units 1-4'
export const GRADES = {
  'grade-k': 'Kindergarten',
  'grade-1': 'Grade 1',
  'grade-2': 'Grade 2',
  'grade-3': 'Grade 3',
  'grade-4': 'Grade 4',
  'grade-5': 'Grade 5',
  'grade-6': 'Grade 6',
  'grade-7': 'Grade 7',
  'grade-8': 'Grade 8',
  'grade-dwb-k': 'Kindergarten',
  'grade-dwb-1': 'Grade 1',
  'grade-dwb-2': 'Grade 2',
  'grade-dwb-3': 'Grade 3',
  'grade-dwb-4': 'Grade 4',
  'grade-dwb-5': 'Grade 5',
  'grade-dwb-6': 'Grade 6',
  'grade-dwb-7': 'Grade 7',
  'grade-dwb-8': 'Grade 8',
  'grade-dwb-9': 'Grade 9',
  'grade-dwb-10': 'Grade 10',
  'grade-dwb-11': 'Grade 11',
  'grade-dwb-12': 'Grade 12',
}
export const SINGULAR_CLASS = 'class'
export const MULTI_CLASSES = 'classes'
export const LESSONS_NOT_STARTED_MULTIPLE_CLASSES = `haven't started teaching yet`
export const LESSONS_NOT_STARTED_SINGULAR_CLASS = `hasn't started teaching yet`
